import { EmptyPlayerV3Props, RaptPlayer } from "@kaltura/mediaspace-shared-player";
import { HeroProps } from "../HeroProps";
import { CommonHeroLayout } from "../layout/CommonHeroLayout";

/* eslint-disable-next-line */
export interface RaptHeroProps extends HeroProps, EmptyPlayerV3Props {}

/**
 * Rapt Hero component - always renders a rapt player
 */
export function RaptHero(props: RaptHeroProps) {
    const { entry, playerConfig, onError, onReady } = props;

    return (
        <CommonHeroLayout collapsedHero={props.collapse}>
            <RaptPlayer
                entryId={entry.id}
                config={playerConfig}
                onError={onError}
                onReady={onReady}
                className={"kms-ds-media-page-rapt-player"}
            />
        </CommonHeroLayout>
    );
}

export default RaptHero;
